import React, { useState, useEffect } from 'react';
import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import N8nChat from '@/components/settings/N8nChat';

const FloatingChat: React.FC = () => {
  const { isAdmin } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  // Сохраняем состояние в localStorage
  useEffect(() => {
    const savedState = localStorage.getItem('floating-chat-open');
    if (savedState) {
      setIsOpen(JSON.parse(savedState));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('floating-chat-open', JSON.stringify(isOpen));
  }, [isOpen]);

  // Показываем только администраторам
  if (!isAdmin) return null;

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Кнопка-триггер */}
      {!isOpen && (
        <Button
          onClick={handleToggle}
          className="fixed bottom-6 right-6 h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 z-50 bg-primary hover:bg-primary/90"
          size="icon"
        >
          <MessageSquare className="h-6 w-6" />
        </Button>
      )}

      {/* N8N Чат в минимальном контейнере */}
      {isOpen && (
        <div className="fixed bottom-6 right-6 z-50">
          <N8nChat onClose={handleClose} />
        </div>
      )}
    </>
  );
};

export default FloatingChat;